import { render, staticRenderFns } from "./ListaExtratoCard.vue?vue&type=template&id=7aaa8acd"
import script from "./ListaExtratoCard.vue?vue&type=script&lang=js"
export * from "./ListaExtratoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports